import React from "react";
import { numberForamting } from "../../../utils/globalUtils";

export default class CurrencyComponent extends React.Component {
  constructor(props) {
    super(props);
    this.inputId = `${Math.round(Math.random() * 10 ** 10)}`;
    this.state = {
      data: JSON.parse(JSON.stringify(this.props)),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ data: this.props });
    }
  }

  onChangeData = e => {
    const data = { ...this.state.data };
    data.value = e.target.value;
    this.setState(() => ({ data }));
  };

  render() {
    const { id, value, editable, currencyIcon } = this.state.data;
    return (
      <React.Fragment>
        <span className="currency-icon">
          {currencyIcon}
          {!editable ? (
            numberForamting(value)
          ) : (
            <input
              id={id || this.inputId}
              type="number"
              value={value}
              onChange={e => this.onChangeData(e)}
              onBlur={() =>
                this.props.onBlurData(parseFloat(this.state.data.value))
              }
              data-test="currencycomponent-input"
            />
          )}
        </span>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGridTypeComponents/CurrencyComponent.js